export const timeToMilliseconds = (timeString: string):number => {
  if (!timeString) return 0;

  const [hours, minutes] = timeString.split(':').map(Number);

  return hours * 3600000 + minutes * 60000;
}
